module.exports = __webpack_public_path__ + "static/media/no-image.8dc2c281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-image.png
// module id = 1137
// module chunks = 0